<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">

        <!--<UpdateObjects v-bind:order_data="order_data" v-bind:session_data="session_data"></UpdateObjects>-->
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-12">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Select your household data</div>

                    <div class="app_border layout__overflow-hidden">
                        <v-card flat>
                            <v-container class="main-container">
                                <v-row>
                                    <v-col class="data-column">
                                        <v-container class="data-container">
                                            <div class="text__size-22 text__colour-grey text__style-bold layout__display-inline-block layout__position-top">
                                                Search by:&nbsp;
                                            </div>

                                            <v-toolbar class="data-tabs layout__display-inline-block" flat>
                                                <template>
                                                    <v-tabs v-model="tabs">
                                                        <v-tooltip top max-width="500px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-tab v-bind="attrs" v-on="on">
                                                                    Location
                                                                </v-tab>
                                                            </template>
                                                            <span>Search using a specific location by entering an town or postcode below.</span>
                                                        </v-tooltip>

                                                        <!--<v-tooltip top max-width="500px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-tab v-bind="attrs" v-on="on">
                                                                    Area
                                                                </v-tab>
                                                            </template>
                                                            <span></span>
                                                        </v-tooltip>-->

                                                        <v-tooltip top max-width="500px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-tab v-bind="attrs" v-on="on">
                                                                    Radius
                                                                </v-tab>
                                                            </template>
                                                            <span>Drop a pin on the map and search within a defined radius. You're able to increase or decrease the search area by choosing from the dropdown menu below.</span>
                                                        </v-tooltip>

                                                        <v-tooltip top max-width="500px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-tab v-bind="attrs" v-on="on">
                                                                    20/20
                                                                </v-tab>
                                                            </template>
                                                            <span>Target properties around a certain postcode, add in a door number and postcode (separated by a comma) and tell the neighbours of your success. You can choose to target up to 200 properties, 100 each side of the property you’ve sold.</span>
                                                        </v-tooltip>
                                                    </v-tabs>
                                                </template>
                                            </v-toolbar>

                                            <v-tabs-items class="data-tab-items layout__margin__top-30" v-model="tabs">
                                                <v-tab-item>
                                                    <v-card flat>
                                                        <div class="text__size-20 text__colour-grey text__style-bold">
                                                            I want to reach households near
                                                        </div>

                                                        <v-row class="height-60px">
                                                            <v-col cols="12" sm="12">
                                                                <el-input autofocus v-model="currentPlace" class="inline-block search-field" id="searchTextField" placeholder="Enter town or postcode">
                                                                </el-input>

                                                                <span>
                                                                    <v-btn class="custom-btn search-btn inline-block" :ripple="false" tile light small depressed @click="addPinToMap()">
                                                                        Search
                                                                    </v-btn>
                                                                </span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-tab-item>

                                                <!--<v-tab-item>
                                                    <v-card flat>
                                                        <div class="text__size-14 text__colour-grey text__style-bold">
                                                            Use +Draw Area button below to add one or more areas
                                                        </div>

                                                        <div>
                                                            <v-btn class="custom-btn add-pin-btn"
                                                                    :class="add_pin_class" :ripple="false"
                                                                    tile dark small depressed
                                                                    @click="addArea()">
                                                                <v-icon class="font-size-18">mdi-plus
                                                                </v-icon>
                                                                Draw Area&nbsp;
                                                            </v-btn>
                                                        </div>
                                                    </v-card>
                                                </v-tab-item>-->

                                                <v-tab-item>
                                                    <v-card flat>
                                                        <div class="text__size-14 text__colour-grey text__style-bold">
                                                            I want to reach households in my drawn radius (click on the map to draw your radius)
                                                        </div>

                                                        <div>
                                                            <!--<v-btn class="custom-btn add-pin-btn"
                                                                    :ripple="false"
                                                                    tile dark small depressed
                                                                    @click="addPin()">
                                                                <v-icon class="font-size-18">mdi-plus
                                                                </v-icon>
                                                                Add Pin&nbsp;
                                                            </v-btn>-->

                                                            <v-select class="radius_dropdown"
                                                                    v-model="radius"
                                                                    :items="radius_choices"
                                                                    item-text="text"
                                                                    item-value="value"
                                                                    label=""
                                                                    :menu-props="{contentClass: 'instant_marketing_dropdown_menu'}"
                                                                    @change="radiusSelected()"
                                                            ></v-select>

                                                            <v-btn class="custom-btn select-btn-units"
                                                                    :ripple="false"
                                                                    tile small depressed @click="clickDistanceUnit()">{{
                                                                distance_unit }}
                                                            </v-btn>

                                                            <el-input autofocus v-model="currentPlaceRadius" class="inline-block search-field" id="searchTextField">
                                                            </el-input>
                                                            <span>
                                                                <v-btn class="custom-btn search-btn inline-block" :ripple="false" tile light small depressed @click="addRadiusTextSearch()">
                                                                    Search
                                                                </v-btn>
                                                            </span>

                                                            <v-row class="radius-row">
                                                                <v-col class="radius-col">
                                                                    <span :class="circlelatlng_class_1" class="radius-span text__colour-0000ff" id="radius-span-1">Radius 1
                                                                        <v-icon class="text__size-16-important remove-circle" @click="removeCircle(1)">mdi-window-close
                                                                        </v-icon>
                                                                    </span>
                                                                    <span :class="circlelatlng_class_2" class="radius-span text__colour-00ff00" id="radius-span-2">Radius 2
                                                                        <v-icon class="text__size-16-important remove-circle" @click="removeCircle(2)">mdi-window-close
                                                                        </v-icon>
                                                                    </span>
                                                                </v-col>
                                                                <v-col class="radius-col">
                                                                    <span :class="circlelatlng_class_3" class="radius-span text__colour-ff0000" id="radius-span-3">Radius 3
                                                                        <v-icon class="text__size-16-important remove-circle" @click="removeCircle(3)">mdi-window-close
                                                                        </v-icon>
                                                                    </span>
                                                                    <span :class="circlelatlng_class_4" class="radius-span text__colour-ff00ff" id="radius-span-4">Radius 4
                                                                        <v-icon class="text__size-16-important remove-circle" @click="removeCircle(4)">mdi-window-close
                                                                        </v-icon>
                                                                    </span>
                                                                </v-col>
                                                            </v-row>

                                                            <v-row class="drawing-div">
                                                                <!--<v-row :class="markers_drawing_class">
                                                                    <span class="drawing">Adding property markers...</span>
                                                                </v-row>-->
                                                                <v-row :class="pinlatlng_class">
                                                                    <span class="pinlatlng">{{ pinlatlng }}<v-icon
                                                                            class="font-size-20 remove-pin"
                                                                            @click="removePin()">mdi-window-close</v-icon></span>
                                                                </v-row>
                                                                <v-row :class="circle_drawing_class">
                                                                    <span class="drawing">Drawing...</span>
                                                                </v-row>
                                                            </v-row>
                                                        </div>
                                                    </v-card>
                                                </v-tab-item>

                                                <v-tab-item>
                                                    <v-card flat>
                                                        <div class="text__size-20 text__colour-grey text__style-bold">
                                                            Target&nbsp;
                                                                <v-select class="twenty_twenty_dropdown"
                                                                        v-model="twentyTwenty"
                                                                        :items="twenty_twenty_choices"
                                                                        item-text="text"
                                                                        item-value="value"
                                                                        background-color="#ffffff"
                                                                        label=""
                                                                        :menu-props="{contentClass: 'instant_marketing_dropdown_menu'}"
                                                                        @change="twentyTwentySelected()"
                                                                ></v-select>
                                                            &nbsp;households nearest to
                                                        </div>

                                                        <v-row class="height-60px no-margin-bottom">
                                                            <v-col cols="12" sm="12">
                                                                <el-input autofocus v-model="currentPlace2020" class="inline-block search-field" id="searchTextField2020">
                                                                </el-input>

                                                                <span>
                                                                    <v-btn class="custom-btn search-btn inline-block" :ripple="false" tile dark small depressed @click="addPinToMap()">
                                                                        Search
                                                                    </v-btn>
                                                                </span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-tab-item>
                                            </v-tabs-items>

                                            <div>
                                                <v-card flat>
                                                    <div class="text__size-12 text__colour-grey text__style-bold">
                                                        Use the + icons below to apply your filters and click on the pre-filled boxes to change your criteria
                                                    </div>

                                                    <v-row class="height-120px">
                                                        <div class="layout__display-contents">
                                                            <div class="grey lighten-3 selection-div">
                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-tooltip
                                                                                :disabled="!show_council_tax_band_tooltip"
                                                                                right
                                                                            >
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn class="custom-btn icon-btn"
                                                                                        v-bind="attrs"
                                                                                        v-on="on"
                                                                                        :class="council_tax_band_icon_classes"
                                                                                        :ripple="false" tile x-small depressed
                                                                                        @click="clickBandIcon()">
                                                                                        <v-icon small>{{ icon_choices[council_tax_band_icon] }}</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>Please use either the Council Tax band field or the House Value field</span>
                                                                            </v-tooltip>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">with tax band</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-1"
                                                                            :class="council_tax_classes_1" :ripple="false"
                                                                            tile small depressed @click="clickBand1()">{{
                                                                        council_tax_band_1_choices[council_tax_band_1] }}
                                                                    </v-btn>
                                                                    <v-btn class="custom-btn select-btn-2"
                                                                            :class="council_tax_classes_2" :ripple="false"
                                                                            tile small depressed @click="clickBand2()">{{
                                                                        council_tax_band_2_choices[council_tax_band_2] }}
                                                                    </v-btn>
                                                                    <span class="custom-text-2"
                                                                            :class="council_tax_classes_3"
                                                                            id="council_tax_band_3_text">
                                                                        <span class="vertical-center">and</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-3"
                                                                            :class="council_tax_classes_4"
                                                                            id="council_tax_band_3_value" :ripple="false"
                                                                            tile small depressed @click="clickBand3()">{{
                                                                        council_tax_band_2_choices[council_tax_band_3] }}
                                                                    </v-btn>
                                                                    <span class="icon-container"
                                                                            :class="council_tax_classes_5">
                                                                        <span class="vertical-center">
                                                                            <v-dialog v-model="council_tax_bands_dialog"
                                                                                    persistent max-width="600px">
                                                                                <template v-slot:activator="{ on }">
                                                                                    <v-btn class="custom-btn list-btn"
                                                                                        :class="council_tax_classes_1"
                                                                                        :ripple="false" tile x-small
                                                                                        depressed v-on="on">
                                                                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <v-card>
                                                                                    <v-card-title>
                                                                                        <span class="headline">Select Council Tax Bands</span>
                                                                                    </v-card-title>
                                                                                    <v-card-text>
                                                                                        <v-container>
                                                                                            <v-layout row wrap align-start>
                                                                                                <ul class="nolist">
                                                                                                    <li class="nolist"
                                                                                                        v-for="(e,index) in council_tax_band_2_choices">
                                                                                                        <v-checkbox
                                                                                                                :key="index"
                                                                                                                v-model="selected_council_tax_bands"
                                                                                                                :value="e"
                                                                                                                :label="e"
                                                                                                                :hide-details="index !== (council_tax_band_2_choices.length - 1)"
                                                                                                        >
                                                                                                        </v-checkbox>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </v-layout>
                                                                                        </v-container>
                                                                                    </v-card-text>
                                                                                    <v-card-actions>
                                                                                        <v-spacer></v-spacer>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="council_tax_bands_dialog = false">Close</v-btn>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="council_tax_bands_dialog = false">Save</v-btn>
                                                                                    </v-card-actions>
                                                                                </v-card>
                                                                            </v-dialog>
                                                                        </span>
                                                                    </span>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-tooltip
                                                                                :disabled="!show_house_value_tooltip"
                                                                                right
                                                                            >
                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                    <v-btn class="custom-btn icon-btn"
                                                                                        v-bind="attrs"
                                                                                        v-on="on"
                                                                                        :class="house_value_icon_classes"
                                                                                        :ripple="false" tile x-small depressed
                                                                                        @click="clickHouseValueIcon()">
                                                                                        <v-icon small>{{ icon_choices[house_value_icon] }}</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>Please use either the Council Tax band field or the House Value field</span>
                                                                            </v-tooltip>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">that are worth</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-1"
                                                                            :class="house_value_classes_1" :ripple="false"
                                                                            tile small depressed @click="clickHouseValue1()">
                                                                        {{ house_value_1_choices[house_value_1] }}
                                                                    </v-btn>
                                                                    <v-btn class="custom-btn select-btn-2"
                                                                            :class="house_value_classes_1" :ripple="false"
                                                                            tile small depressed @click="clickHouseValue2()">
                                                                        {{ house_value_2_choices[house_value_2] }}
                                                                    </v-btn>
                                                                    <span class="custom-text-2"
                                                                            :class="house_value_classes_2"
                                                                            id="house_value_3_text">
                                                                        <span class="vertical-center">and</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-3"
                                                                            :class="house_value_classes_3"
                                                                            id="house_value_3_value" :ripple="false" tile
                                                                            small depressed @click="clickHouseValue3()">{{
                                                                        house_value_3_choices[house_value_3] }}
                                                                    </v-btn>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-btn class="custom-btn icon-btn" :ripple="false"
                                                                                tile color="grey" dark x-small depressed
                                                                                @click="clickOccupierIcon()">
                                                                                <v-icon small>{{ icon_choices[occupier_icon] }}</v-icon>
                                                                            </v-btn>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">occupied by</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn"
                                                                            :class="occupier_classes" :ripple="false" tile
                                                                            dark small depressed @click="clickOccupier()">{{
                                                                        occupier_choices[occupier] }}
                                                                    </v-btn>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-btn class="custom-btn icon-btn" :ripple="false"
                                                                                tile color="grey" dark x-small depressed
                                                                                @click="clickResidenceTypeIcon()">
                                                                                <v-icon small>{{ icon_choices[residence_type_icon] }}</v-icon>
                                                                            </v-btn>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">house type</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn"
                                                                            :class="residence_type_classes_1" :ripple="false"
                                                                            tile small depressed
                                                                            @click="clickResidenceType()">{{
                                                                        residence_type_choices[residence_type] }}
                                                                    </v-btn>
                                                                    <span class="icon-container"
                                                                            :class="residence_type_classes_2">
                                                                        <span class="vertical-center">
                                                                            <v-dialog v-model="residence_types_dialog"
                                                                                    persistent max-width="600px">
                                                                                <template v-slot:activator="{ on }">
                                                                                    <v-btn class="custom-btn list-btn"
                                                                                        :class="residence_type_classes_2"
                                                                                        :ripple="false" tile x-small
                                                                                        depressed v-on="on">
                                                                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <v-card>
                                                                                    <v-card-title>
                                                                                        <span class="headline">Select Residence Types</span>
                                                                                    </v-card-title>
                                                                                    <v-card-text>
                                                                                        <v-container>
                                                                                            <v-layout row wrap align-start>
                                                                                                <ul class="nolist">
                                                                                                    <li class="nolist"
                                                                                                        v-for="(e,index) in residence_type_choices">
                                                                                                        <div v-if="e != 'multiple'">
                                                                                                            <v-checkbox
                                                                                                                    :key="index"
                                                                                                                    v-model="selected_residence_types"
                                                                                                                    :value="e"
                                                                                                                    :label="e"
                                                                                                                    :hide-details="index !== (residence_type_choices.length - 1)"
                                                                                                            >
                                                                                                            </v-checkbox>
                                                                                                        </div>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </v-layout>
                                                                                        </v-container>
                                                                                    </v-card-text>
                                                                                    <v-card-actions>
                                                                                        <v-spacer></v-spacer>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="residence_types_dialog = false">Close</v-btn>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="residence_types_dialog = false">Save</v-btn>
                                                                                    </v-card-actions>
                                                                                </v-card>
                                                                            </v-dialog>
                                                                        </span>
                                                                    </span>
                                                                </v-row>

                                                                <v-row>
                                                                    <v-layout align-end justify-end>
                                                                        <v-btn class="custom-btn apply-btn float-right"
                                                                                :ripple="false" tile color="grey" dark small
                                                                                depressed @click="applyFilters()">
                                                                            Apply
                                                                        </v-btn>
                                                                    </v-layout>
                                                                </v-row>
                                                            </div>

                                                            <!--<div class="count-parent-div">
                                                                <div>
                                                                    <v-row class="drawing-div">
                                                                        <v-row :class="pin_drawing_class">
                                                                            <span class="drawing">Drawing...</span>
                                                                        </v-row>
                                                                        <v-row :class="markers_drawing_class">
                                                                            <span class="drawing">Adding property markers...</span>
                                                                        </v-row>
                                                                        <v-row :class="pinlatlng_class">
                                                                            <span class="pinlatlng">{{ pinlatlng }}<v-icon
                                                                                    class="font-size-20 remove-pin"
                                                                                    @click="removePin()">mdi-window-close</v-icon></span>
                                                                        </v-row>
                                                                        <v-row :class="circle_drawing_class">
                                                                            <span class="drawing">Drawing...</span>
                                                                        </v-row>
                                                                    </v-row>
                                                                </div>
                                                            </div>-->
                                                        </div>
                                                    </v-row>
                                                </v-card>
                                            </div>

                                            <div class="count-div height-35px"
                                                    :class="{'flashing':flashing}">
                                                <span class="margin-left-10 line-height-2-2 display-inline-block">Records returned:</span>
                                                <span class="font-size-24 margin-right-10 float-right">{{ record_count }}</span>
                                            </div>
                                        </v-container>
                                    </v-col>

                                    <v-col>
                                        <gmap-map
                                                id="map"
                                                ref="map"
                                                :center="center"
                                                :zoom="15"
                                                style="width:100%; height: 100%;"
                                                v-on:click="getLocation">
                                            <gmap-marker
                                                    :key="'pin'+index"
                                                    v-for="(m, index) in pins"
                                                    :position="m.position"
                                                    @click="center=m.position"
                                                    :draggable="true"
                                                    @dragend="pinDragged(index,$event.latLng)"
                                            ></gmap-marker>
                                            <gmap-marker
                                                    :key="'marker'+index"
                                                    v-for="(m, index) in markers_array"
                                                    :position="m.position"
                                                    :clickable="false"
                                                    :draggable="false"
                                                    :icon="m.markerOptions"
                                            ></gmap-marker>
                                            <gmap-polygon :paths="areas"
                                            ></gmap-polygon>
                                            <GmapCircle
                                                    v-for="(pin, index) in circles"
                                                    :key="index"
                                                    :center="pin.position"
                                                    :radius="pin.distance"
                                                    :options="{clickable: false, draggable: true, editable: true, fillColor: pin.colour, fillOpacity: 0.25, strokeColor: pin.colour, strokeOpacity: 0.5, strokeWeight: 2, visible: pin.visibility}"
                                                    @click="center=m.position"
                                                    @radius_changed="radiusChanged(index, $event)"
                                                    @center_changed="centerChanged(index, $event)"
                                            ></GmapCircle>
                                        </gmap-map>

                                        <div class="text__size-16 text__colour-grey text__style-bold" v-show="tab_selected == 'radius'">
                                            Use the white markers to move and adjust the size of your radius
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <div class="layout__padding__top-20px">
                                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                                    v-on:click="navigate('fulfilment');">Back
                                            </el-button>

                                            <el-button :disabled="!this.record_count" class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right"
                                                    v-on:click="previewData()">Preview your data
                                            </el-button>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>

                        <v-dialog v-model="errorDialog" width="500">
                            <v-card>
                                <v-card-title class="headline grey lighten-2" primary-title></v-card-title>

                                <v-card-text>
                                    Please enter a search term
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" text @click="errorDialog = false">
                                        Ok
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--<el-dialog
                                :visible.sync="errorDialog"
                                :close-on-press-escape="false"
                                :close-on-click-modal="false"
                                :show-close="false"
                                width="500px">
                            <div class="layout__position-center text__align-center" v-show="errorDialog">
                                <p class="layout__margin__bottom-6px layout__padding__top-16px">Please enter a search term<br></p>
                                <div class="layout__padding-clear">
                                    <div class="layout__padding-20-0">
                                        <el-button class="button-teal button__base layout__width-150px"
                                                v-on:click="errorDialog = false">Ok
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-dialog>-->

                        <v-overlay :value="loading">
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import qs from 'qs';
    import {axios} from '@/mixins/Axios.js';
    import {gmapApi} from 'vue2-google-maps';

    export default {
        name: "GoogleMap",
        data() {
            return {
                connection_params: {},
                data_url: '',
                dataProvider: 'Databook',
                query_string: '',
                order: {},
                //center: {},
                center: {
                    lat: 0,
                    lng: 0
                },
                pins: [],
                circles: [],
                circle1_selected: false,
                circle2_selected: false,
                circle3_selected: false,
                circle4_selected: false,
                areas: [],
                places: [],
                markers_array: [],
                tabs: null,
                tab_selected: '',
                errorDialog: false,
                addingCircle: false,
                add_pin_disabled: false,
                add_circle_disabled: false,
                loading: false,
                twentyTwenty: '80',
                radius: { 'text': '1km', 'value': '1' },
                distance: 100,
                distance_unit: 'km',
                area_colour: null,
                radius_count: 0,
                currentPlace: '',
                currentPlaceRadius: '',
                currentPlace2020: '',
                pinlatlng: '',
                circlelatlng: '',
                flashing: false,
                databook_auth_token: '',
                record_count: 0,
                show_council_tax_band_tooltip: false,
                council_tax_band_icon: 0,
                council_tax_band_1: 0,
                council_tax_band_2: 0,
                council_tax_band_3: 2,
                council_tax_band_2_hidden: '',
                council_tax_band_3_hidden: 'hidden',
                council_tax_bands_dialog: false,
                selected_council_tax_bands: [],
                multiple_band_hidden: 'hidden',
                show_house_value_tooltip: false,
                house_value_icon: 0,
                house_value_1: 0,
                house_value_2: 0,
                house_value_3: 1,
                house_value_hidden: 'hidden',
                occupier_icon: 0,
                occupier: 0,
                residence_type_icon: 0,
                residence_type: 0,
                residence_types_dialog: false,
                selected_residence_types: [],
                multiple_residence_type_hidden: 'hidden',
                multiple_residence_type_class: '',
                map_colours: [
                    '#0000ff',
                    '#00ff00',
                    '#ff0000',
                    '#ff00ff',
                    '#00ffff',
                    '#000000',
                    '#cccc00',
                    '#00aa00',
                    '#aa0000',
                    '#aa00aa',
                    '#00aaaa',
                    '#666666',
                    '#006600',
                    '#660000',
                    '#660066',
                    '#006666'
                ],
                items: [
                    'more than',
                    'less than',
                    'only',
                ],
                twenty_twenty_choices: [{
                    'text': '20/20 - 40 addresses',
                    'value': '40'
                }, {
                    'text': '40/40 - 80 addresses',
                    'value': '80'
                }, {
                    'text': '60/60 - 120 addresses',
                    'value': '120'
                }, {
                    'text': '80/80 - 160 addresses',
                    'value': '160'
                }, {
                    'text': '100/100 - 200 addresses',
                    'value': '200'
                }],
                radius_choices: [],
                radius_choices_km: [{
                    'text': '25m',
                    'value': '0.025'
                }, {
                    'text': '50m',
                    'value': '0.05'
                }, {
                    'text': '100m',
                    'value': '0.1'
                }, {
                    'text': '150m',
                    'value': '0.15'
                }, {
                    'text': '200m',
                    'value': '0.2'
                }, {
                    'text': '0.25km',
                    'value': '0.25'
                }, {
                    'text': '0.5km',
                    'value': '0.5'
                }, {
                    'text': '1km',
                    'value': '1'
                }, {
                    'text': '1.5km',
                    'value': '1.5'
                }, {
                    'text': '2km',
                    'value': '2'
                }, {
                    'text': '3km',
                    'value': '3'
                }, {
                    'text': '5km',
                    'value': '5'
                }, {
                    'text': '7.5km',
                    'value': '7.5'
                }, {
                    'text': '10km',
                    'value': '10'
                }],
                radius_choices_miles: [{
                    'text': '25m',
                    'value': '0.025'
                }, {
                    'text': '50m',
                    'value': '0.05'
                }, {
                    'text': '100m',
                    'value': '0.1'
                }, {
                    'text': '150m',
                    'value': '0.15'
                }, {
                    'text': '200m',
                    'value': '0.2'
                }, {
                    'text': '0.25mi',
                    'value': '0.402336'
                }, {
                    'text': '0.5mi',
                    'value': '0.804672'
                }, {
                    'text': '1mi',
                    'value': '1.609344'
                }, {
                    'text': '1.5mi',
                    'value': '2.414016'
                }, {
                    'text': '2mi',
                    'value': '3.218688'
                }, {
                    'text': '3mi',
                    'value': '4.828032'
                }, {
                    'text': '5mi',
                    'value': '8.04672'
                }, {
                    'text': '7.5mi',
                    'value': '12.07008'
                }, {
                    'text': '10mi',
                    'value': '16.09344'
                }],
                radius_metres: {
                    '0.025': [25],
                    '0.050': [50],
                    '0.1': [100],
                    '0.15': [150],
                    '0.2': [200],
                    '0.25': [250],
                    '0.5': [500],
                    '1': [1000],
                    '1': [1500],
                    '2': [2000],
                    '3': [3000],
                    '5': [5000],
                    '7.5': [7500],
                    '10': [10000]
                },

                icon_choices: [
                    'mdi-plus',
                    'mdi-minus'
                ],
                council_tax_band_1_choices: [
                    'more than',
                    'less than',
                    'between',
                    'only'
                ],
                council_tax_band_2_choices: [
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    'I'
                ],
                house_value_1_choices: [
                    'more than',
                    'less than',
                    'between'
                ],
                house_value_2_choices: [
                    '100k',
                    '150k',
                    '250k',
                    '500k',
                    '750k',
                    '1m',
                    '2m'
                ],
                house_value_3_choices: [
                    '100k',
                    '150k',
                    '250k',
                    '500k',
                    '750k',
                    '1m',
                    '2m'
                ],
                occupier_choices: [
                    'homeowner',
                    'private renting',
                    'social renting'
                ],
                residence_type_choices: [
                    'Detached house',
                    'Semi-detached house',
                    'Bungalow',
                    'Terraced house',
                    'Flat or maisonette',
                    'multiple'
                ],
                switchable_opts: {
                    'more than': {
                        '100k': ['lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m', 'lukp_hhdval2mp'],
                        '150k': ['lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m', 'lukp_hhdval2mp'],
                        '250k': ['lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m', 'lukp_hhdval2mp'],
                        '500k': ['lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m', 'lukp_hhdval2mp'],
                        '750k': ['lukp_hhdval750to1m', 'lukp_hhdval1to2m', 'lukp_hhdval2mp'],
                        '1m': ['lukp_hhdval1to2m', 'lukp_hhdval2mp'],
                        '2m': ['lukp_hhdval2mp'],
                        'A': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
                        'B': ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
                        'C': ['C', 'D', 'E', 'F', 'G', 'H', 'I'],
                        'D': ['D', 'E', 'F', 'G', 'H', 'I'],
                        'E': ['E', 'F', 'G', 'H', 'I'],
                        'F': ['F', 'G', 'H', 'I'],
                        'G': ['G', 'H', 'I'],
                        'H': ['H', 'I'],
                        'I': ['I']
                    },
                    'less than': {
                        '100k': ['lukp_hhdval0to100k'],
                        '150k': ['lukp_hhdval0to100k', 'lukp_hhdval100to150k'],
                        '250k': ['lukp_hhdval0to100k', 'lukp_hhdval100to150k', 'lukp_hhdval150to250k'],
                        '500k': ['lukp_hhdval0to100k', 'lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k'],
                        '750k': ['lukp_hhdval0to100k', 'lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k'],
                        '1m': ['lukp_hhdval0to100k', 'lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m'],
                        '2m': ['lukp_hhdval0to100k', 'lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m'],
                        'A': ['A'],
                        'B': ['A', 'B'],
                        'C': ['A', 'B', 'C'],
                        'D': ['A', 'B', 'C', 'D'],
                        'E': ['A', 'B', 'C', 'D', 'E'],
                        'F': ['A', 'B', 'C', 'D', 'E', 'F'],
                        'G': ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
                        'H': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
                        'I': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']
                    },
                    'between': {
                        '100k-150k': ['lukp_hhdval100to150k'],
                        '100k-250k': ['lukp_hhdval100to150k', 'lukp_hhdval150to250k'],
                        '100k-500k': ['lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k'],
                        '100k-750k': ['lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k'],
                        '100k-1m': ['lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m'],
                        '100k-2m': ['lukp_hhdval100to150k', 'lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m'],
                        '150k-250k': ['lukp_hhdval150to250k'],
                        '150k-500k': ['lukp_hhdval150to250k', 'lukp_hhdval250to500k'],
                        '150k-750k': ['lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k'],
                        '150k-1m': ['lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m'],
                        '150k-2m': ['lukp_hhdval150to250k', 'lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m'],
                        '250k-500k': ['lukp_hhdval250to500k'],
                        '250k-750k': ['lukp_hhdval250to500k', 'lukp_hhdval500to750k'],
                        '250k-1m': ['lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m'],
                        '250k-2m': ['lukp_hhdval250to500k', 'lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m'],
                        '500k-750k': ['lukp_hhdval500to750k'],
                        '500k-1m': ['lukp_hhdval500to750k', 'lukp_hhdval750to1m'],
                        '500k-2m': ['lukp_hhdval500to750k', 'lukp_hhdval750to1m', 'lukp_hhdval1to2m'],
                        '750k-1m': ['lukp_hhdval750to1m'],
                        '750k-2m': ['lukp_hhdval750to1m', 'lukp_hhdval1to2m'],
                        '1m-2m': ['lukp_hhdval1to2m'],
                        '2m-2m': ['lukp_hhdval2mp'],
                        'A-B': ['A', 'B'],
                        'A-C': ['A', 'B', 'C'],
                        'A-D': ['A', 'B', 'C', 'D'],
                        'A-E': ['A', 'B', 'C', 'D', 'E'],
                        'A-F': ['A', 'B', 'C', 'D', 'E', 'F'],
                        'A-G': ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
                        'A-H': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
                        'A-I': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
                        'B-C': ['B', 'C'],
                        'B-D': ['B', 'C', 'D'],
                        'B-E': ['B', 'C', 'D', 'E'],
                        'B-F': ['B', 'C', 'D', 'E', 'F'],
                        'B-G': ['B', 'C', 'D', 'E', 'F', 'G'],
                        'B-H': ['B', 'C', 'D', 'E', 'F', 'G', 'H'],
                        'B-I': ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
                        'C-D': ['C', 'D'],
                        'C-E': ['C', 'D', 'E'],
                        'C-F': ['C', 'D', 'E', 'F'],
                        'C-G': ['C', 'D', 'E', 'F', 'G'],
                        'C-H': ['C', 'D', 'E', 'F', 'G', 'H'],
                        'C-I': ['C', 'D', 'E', 'F', 'G', 'H', 'I'],
                        'D-E': ['D', 'E'],
                        'D-F': ['D', 'E', 'F'],
                        'D-G': ['D', 'E', 'F', 'G'],
                        'D-H': ['D', 'E', 'F', 'G', 'H'],
                        'D-I': ['D', 'E', 'F', 'G', 'H', 'I'],
                        'E-F': ['E', 'F'],
                        'E-G': ['E', 'F', 'G'],
                        'E-H': ['E', 'F', 'G', 'H'],
                        'E-I': ['E', 'F', 'G', 'H', 'I'],
                        'F-G': ['F', 'G'],
                        'F-H': ['F', 'G', 'H'],
                        'F-I': ['F', 'G', 'H', 'I'],
                        'G-H': ['G', 'H'],
                        'G-I': ['G', 'H', 'I'],
                        'H-I': ['H', 'I']
                    },
                    'house_value_1': [
                        'more than',
                        'less than',
                        'between'
                    ],
                    'house_value_2': {
                        '100k': 'lukp_hhdval0to100k',
                        '150k': 'lukp_hhdval100to150k',
                        '250k': 'lukp_hhdval150to250k',
                        '500k': 'lukp_hhdval250to500k',
                        '750k': 'lukp_hhdval500to750k',
                        '1m': 'lukp_hhdval750to1m',
                        '2m': 'lukp_hhdval1to2m'
                    },
                    'council_tax_band_1': [
                        'more than',
                        'less than',
                        'between',
                        'only'
                    ],
                    'council_tax_band_2': {
                        'A': 'A',
                        'B': 'B',
                        'C': 'C',
                        'D': 'D',
                        'E': 'E',
                        'F': 'F',
                        'G': 'G',
                        'H': 'H',
                        'I': 'I'
                    },
                    'occupier': {
                        'homeowner': 'lukp_house5',
                        'private renting': 'lukp_a2_house3',
                        'social renting': 'lukp_a2_house2'
                    },
                    'residence_type': {
                        'Detached house': 'lukp_a2_house5',
                        'Semi-detached house': 'lukp_a2_house7',
                        'Bungalow': 'lukp_a2_house4',
                        'Terraced house': 'lukp_a2_house8',
                        'Flat or maisonette': 'lukp_a2_house6'
                    }
                },
            };
        },
        components: {
        },
        mixins: [axios],
        watch: {
            tabs: function (val) {
                console.log('tabs=' + val);

                if (val == 0) {
                    this.tab_selected = 'location';
                    this.showCircles(false);
                } else if (val == 1) {
                    this.tab_selected = 'radius';
                    this.showCircles(true);
                } else if (val == 2) {
                    this.tab_selected = '2020';
                    this.showCircles(false);
                }

                console.log('this.tab_selected=' + this.tab_selected);
                console.log('this.currentPlace=' + this.currentPlace);
                console.log('this.circles.length=' + this.circles.length);
                console.log('this.currentPlace2020=' + this.currentPlace2020);

                this.markers_array = [];

                var callDatabook = false;

                //if (this.currentPlace !== '' || this.circles.length > 0 || this.currentPlace2020 !== '') {
                //    this.callDatabook();
                //}

                if (this.tab_selected == 'location' && this.currentPlace !== '') {
                    callDatabook = true;
                    console.log('1');
                }

                console.log('this.tab_selected=' + this.tab_selected);
                console.log('this.circles.length=' + this.circles.length);

                if (this.tab_selected == 'radius' && this.circles.length > 0) {
                    callDatabook = true;
                    console.log('2');
                }

                if (this.tab_selected == '2020' && this.currentPlace2020 !== '') {
                    callDatabook = true;
                    console.log('3');
                }

                console.log('callDatabook=' + callDatabook);
                if (callDatabook) {
                    this.callDatabook();
                } else {
                    this.record_count = 0;

                    this.flashing = true;
                    setTimeout(() => this.flashing = false, 200);

                }
            }
        },
        computed: {
            google: gmapApi,
            /*add_pin_class() {
                return {
                    'btn-disabled': this.add_pin_disabled,
                    'btn-enabled': !this.add_pin_disabled,
                }
            },*/
            add_circle_class() {
                return {
                    'btn-disabled': this.add_circle_disabled,
                    'btn-enabled': !this.add_circle_disabled,
                }
            },
            circle_drawing_class() {
                return {
                    'hidden': this.addingCircle == false ? true : false,
                }
            },
            pinlatlng_class() {
                return {
                    'hidden': this.pinlatlng == '' ? true : false,
                }
            },
            circlelatlng_class_1() {
                return {
                    'hidden': !this.circle1_selected,
                }
            },
            circlelatlng_class_2() {
                return {
                    'hidden': !this.circle2_selected,
                }
            },
            circlelatlng_class_3() {
                return {
                    'hidden': !this.circle3_selected,
                }
            },
            circlelatlng_class_4() {
                return {
                    'hidden': !this.circle4_selected,
                }
            },
            preview_data_classes() {
                return {
                    'btn-disabled': this.record_count == 0 ? true : false,
                }
            },
            council_tax_band_icon_classes() {
                return {
                    'btn-disabled': this.house_value_icon == 1 ? true : false,
                    'btn-enabled': this.house_value_icon == 0 ? true : false,
                }
            },
            council_tax_classes_1() {
                return {
                    'btn-disabled': this.council_tax_band_icon == 0 ? true : false,
                    'btn-enabled': this.council_tax_band_icon == 1 ? true : false,
                }
            },
            council_tax_classes_2() {
                return {
                    'btn-disabled': this.council_tax_band_icon == 0 ? true : false,
                    'btn-enabled': this.council_tax_band_icon == 1 ? true : false,
                    'hidden': this.council_tax_band_1_choices[this.council_tax_band_1] == 'only' ? true : false,
                }
            },
            council_tax_classes_3() {
                return {
                    'hidden': this.council_tax_band_1_choices[this.council_tax_band_1] != 'between' ? true : false,
                }
            },
            council_tax_classes_4() {
                return {
                    'btn-disabled': this.council_tax_band_icon == 0 ? true : false,
                    'btn-enabled': this.council_tax_band_icon == 1 ? true : false,
                    'hidden': this.council_tax_band_1_choices[this.council_tax_band_1] != 'between' ? true : false,
                }
            },
            council_tax_classes_5() {
                return {
                    'hidden': this.council_tax_band_1_choices[this.council_tax_band_1] != 'only' ? true : false,
                }
            },
            house_value_icon_classes() {
                return {
                    'btn-disabled': this.council_tax_band_icon == 1 ? true : false,
                    'btn-enabled': this.council_tax_band_icon == 0 ? true : false,
                }
            },
            house_value_classes_1() {
                return {
                    'btn-disabled': this.house_value_icon == 0 ? true : false,
                    'btn-enabled': this.house_value_icon == 1 ? true : false,
                }
            },
            house_value_classes_2() {
                return {
                    'hidden': this.house_value_1_choices[this.house_value_1] != 'between' ? true : false,
                }
            },
            house_value_classes_3() {
                return {
                    'btn-disabled': this.house_value_icon == 0 ? true : false,
                    'btn-enabled': this.house_value_icon == 1 ? true : false,
                    'hidden': this.house_value_1_choices[this.house_value_1] != 'between' ? true : false,
                }
            },
            occupier_classes() {
                return {
                    'btn-disabled': this.occupier_icon == 0 ? true : false,
                    'btn-enabled': this.occupier_icon == 1 ? true : false,
                }
            },
            residence_type_classes_1() {
                return {
                    'btn-disabled': this.residence_type_icon == 0 ? true : false,
                    'btn-enabled': this.residence_type_icon == 1 ? true : false,
                    'multiple-residence_type': this.residence_type_choices[this.residence_type] == 'multiple' ? true : false,
                }
            },
            residence_type_classes_2() {
                return {
                    'btn-disabled': this.residence_type_icon == 0 ? true : false,
                    'btn-enabled': this.residence_type_icon == 1 ? true : false,
                    'hidden': this.residence_type_choices[this.residence_type] != 'multiple' ? true : false,
                }
            },
        },
        created() {
        },
        mounted() {
            parent.postMessage('ScrollIntoView', '*');

            if (window.sessionStorage.getItem('_radius_units') == null) {
                window.sessionStorage.setItem('_radius_units', 'km');
            }

            if (window.sessionStorage.getItem('_radius_value') == null) {
                window.sessionStorage.setItem('_radius_value', '1');
            }

            window.sessionStorage.removeItem('imageUrl');

            this.radius_choices = this.radius_choices_km;

            const getOrderById = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');
            console.log(getOrderById)

            Axios.get(getOrderById, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response.data);

                    var place = {};

                    this.order = response.data[0];
                    console.log('this.order.dataUrl=' + this.order.dataUrl);

                    if (this.order.dataUrl == null) {
                        this.geolocate();
                    } else {
                        if (window.sessionStorage.getItem('_currentPlace') !== "undefined") {
                            this.tab_selected = window.sessionStorage.getItem('_searchType');
                            this.currentPlace = window.sessionStorage.getItem('_currentPlace');
                            this.circles = JSON.parse(window.sessionStorage.getItem('_circles'));
                            this.currentPlace2020 = window.sessionStorage.getItem('_currentPlace2020');

                            if (this.tab_selected == 'location') {
                                this.tabs = 0;
                            } else if (this.tab_selected == 'radius') {
                                this.tabs = 1;
                            } else if (this.tab_selected == '2020') {
                                this.tabs = 2;
                            }
                        }

                        var dataUrl = decodeURIComponent(this.order.dataUrl);
                        console.log('dataUrl=' + dataUrl);

                        var params = dataUrl.split('&');

                        for (var ip = 0; ip < params.length; ip++) {
                            console.log('params[' + ip + ']=' + params[ip]);

                            var param = params[ip].split('=');

                            console.log('param[0]=' + param[0]);

                            if (param[0] == 'near') {
                                var latlng = param[1].split(', ');

                                console.log('latlng[0]=' + parseFloat(latlng[0]));
                                console.log('latlng[1]=' + parseFloat(latlng[1]));

                                this.center = {
                                    lat: parseFloat(latlng[0]),
                                    lng: parseFloat(latlng[1])
                                };
                            }

                            if (param[0] == '2020rows') {
                                this.twentyTwenty = param[1];
                            }

                            if (param[0] == 'radius') {
                                var radius_params = params[ip].split(' ');

                                for (var ir = 0; ir < radius_params.length; ir++) {
                                    console.log('radius_params[' + ir + ']=' + radius_params[ir]);

                                    var radius_param = radius_params[ir].split('=');

                                    if (radius_param[0] == 'd') {
                                        this.radius = radius_param[1];
                                    }

                                    if (radius_param[0] == 'pt') {
                                        var latlng = radius_param[1].split(',');

                                        console.log('latlng[0]=' + parseFloat(latlng[0]));
                                        console.log('latlng[1]=' + parseFloat(latlng[1]));

                                        this.center = {
                                            lat: parseFloat(latlng[0]),
                                            lng: parseFloat(latlng[1])
                                        };
                                    }
                                }

                                if (this.currentPlace == '') {
                                    this.addingCircle = true;
                                }
                            }

                            if (param[0] == 'council_tax_band_selected') {
                                this.council_tax_band_icon = 1;

                                var council_tax_params = param[1].split('||');

                                console.log('council_tax_params[0]=' + council_tax_params[0]);

                                if (council_tax_params[0] == 'more than') {
                                    this.council_tax_band_1 = 0;

                                    var obj = this.switchable_opts.council_tax_band_2,
                                        tax = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == council_tax_params[1]) {
                                                this.council_tax_band_2 = tax;
                                            }
                                        }
                                        tax++;
                                    }

                                } else if (council_tax_params[0] == 'less than') {
                                    this.council_tax_band_1 = 1;

                                    var obj = this.switchable_opts.council_tax_band_2,
                                        tax = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == council_tax_params[1]) {
                                                this.council_tax_band_2 = tax;
                                            }
                                        }
                                        tax++;
                                    }

                                } else if (council_tax_params[0] == 'between') {
                                    this.council_tax_band_1 = 2;

                                    var obj = this.switchable_opts.council_tax_band_2,
                                        tax = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == council_tax_params[1]) {
                                                this.council_tax_band_2 = tax;
                                            }
                                        }
                                        tax++;
                                    }

                                    var obj = this.switchable_opts.council_tax_band_2,
                                        tax = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == council_tax_params[2]) {
                                                this.council_tax_band_3 = tax;
                                            }
                                        }
                                        tax++;
                                    }

                                } else if (council_tax_params[0] == 'only') {
                                    this.council_tax_band_1 = 3;

                                    var council_tax_params_only = council_tax_params[1].split(',');

                                    for (var ic = 0; ic < council_tax_params_only.length; ic++) {
                                        this.selected_council_tax_bands.push(council_tax_params_only[ic]);
                                    }
                                }
                            }

                            if (param[0] == 'house_value_selected') {
                                this.house_value_icon = 1;

                                var house_value_params = param[1].split('||');

                                console.log('house_value_params[0]=' + house_value_params[0]);

                                if (house_value_params[0] == 'more than') {
                                    this.house_value_1 = 0;

                                    var obj = this.house_value_2_choices,
                                        val = 0;
                                    for (var p in obj) {
                                      if (obj.hasOwnProperty(p)) {
                                        if (obj[p] == house_value_params[1]) {
                                                this.house_value_2 = val;
                                            }
                                        }
                                        val++;
                                    }

                                } else if (house_value_params[0] == 'less than') {
                                    this.house_value_1 = 1;

                                    var obj = this.house_value_2_choices,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == house_value_params[1]) {
                                                this.house_value_2 = val;
                                            }
                                        }
                                        val++;
                                    }

                                } else if (house_value_params[0] == 'between') {
                                    this.house_value_1 = 2;

                                    var obj = this.house_value_2_choices,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == house_value_params[1]) {
                                                this.house_value_2 = val;
                                            }
                                        }
                                        val++;
                                    }

                                    var obj = this.house_value_3_choices,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (obj[p] == house_value_params[2]) {
                                                this.house_value_3 = val;
                                            }
                                        }
                                        val++;
                                    }
                                }
                            }

                            if (param[0] == 'occupied_by_filter_selected') {
                                this.occupier_icon = 1;

                                var occupier_params = param[1].split('||');

                                console.log('occupier_params[1]=' + occupier_params[1]);

                                var obj = this.switchable_opts.occupier,
                                    occ = 0;
                                for (var p in obj) {
                                    if (obj.hasOwnProperty(p)) {
                                        if (p == occupier_params[1]) {
                                            this.occupier = occ;
                                        }
                                    }
                                    occ++;
                                }
                            }

                            if (param[0] == 'residence_type_selected') {
                                this.residence_type_icon = 1;

                                var residence_type_params = param[1].split('||');

                                console.log('residence_type_params[0]=' + residence_type_params[0]);
                                console.log('residence_type_params[1]=' + residence_type_params[1]);

                                if (residence_type_params[0] == 'only') {
                                    this.residence_type = 5; //multiple

                                    var residence_type_params_only = residence_type_params[1].split(',');

                                    for (var it = 0; it < residence_type_params_only.length; it++) {
                                        this.selected_residence_types.push(residence_type_params_only[it]);
                                    }

                                } else {
                                    var obj = this.switchable_opts.residence_type,
                                        res = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == residence_type_params[1]) {
                                                this.residence_type = res;
                                            }
                                        }
                                        res++;
                                    }
                                }
                            }
                        }

                        console.log('this.currentPlace=' + this.currentPlace);
                        console.log('this.addingCircle=' + this.addingCircle);

                        if (this.currentPlace !== '') {
                            this.addPinToMap();
                        } else {
                            if (this.addingCircle == true) {
                                console.log('this.circles: ' + JSON.stringify(this.circles));

                                for (var i = 0; i < this.circles.length; i++) {
                                    console.log('this.circles[' + i + '].colour=' + this.circles[i].colour);

                                    if (this.circles[i].colour == this.map_colours[0]) {
                                        this.circle1_selected = true;
                                    } else if (this.circles[i].colour == this.map_colours[1]) {
                                        this.circle2_selected = true;
                                    } else if (this.circles[i].colour == this.map_colours[2]) {
                                        this.circle3_selected = true;
                                    } else if (this.circles[i].colour == this.map_colours[3]) {
                                        this.circle4_selected = true;
                                    }
                                }

                                var radius_value = window.sessionStorage.getItem('_radius_value'),
                                    radius_units = window.sessionStorage.getItem('_radius_units');

                                this.distance_unit = radius_units;

                                if (this.distance_unit === 'km') {
                                    this.radius_choices = this.radius_choices_km;
                                } else {
                                    this.radius_choices = this.radius_choices_miles;
                                }

                                this.setRadius(radius_value);

                                this.radius_count = this.circles.length;
                                this.addingCircle = false;
                            }

                            this.callDatabook();
                        }
                    }
                });
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            change() {
                console.log(this.currentPlace);

                if (this.currentPlace == '') {
                    this.add_pin_disabled = false;
                }
            },
            // receives a place object via the autocomplete component
            setPlace(place) {
                console.log(place)
                this.currentPlace = place;
            },
            // addPin() {
            //     if (event.currentTarget.classList.contains('btn-disabled')) {
            //         return;
            //     }

            //     if (this.radius !== '') {
            //         console.log('adding circle');
            //         this.addingCircle = true;
            //     }
            // },
            // addPin2020() {
            //     if (event.currentTarget.classList.contains('btn-disabled')) {
            //         return;
            //     }

            //     this.addingPin2020 = true;
            // },
            removePin() {
                console.log('removing pin');

                this.pins.splice(0, 1);
                this.pinlatlng = '';
                this.record_count = 0;
                this.markers_array = [];

                window.sessionStorage.removeItem('qs');
            },
            addCircleToMap() {
                if (event.currentTarget.classList.contains('btn-disabled')) {
                    return;
                }

                console.log('adding radius');

                this.addingCircle = true;
            },
            removeCircle(radius_selected) {
                console.log('removing circle');

                this.circles.splice(radius_selected - 1, 1);

                if (radius_selected == 1) {
                    this.circle1_selected = false;
                } else if (radius_selected == 2) {
                    this.circle2_selected = false;
                } else if (radius_selected == 3) {
                    this.circle3_selected = false;
                } else if (radius_selected == 4) {
                    this.circle4_selected = false;
                }

                --this.radius_count;
                if (this.radius_count < 0) {
                    this.radius_count == 0;
                }

                this.markers_array = [];

                window.sessionStorage.removeItem('qs');

                console.log('this.radius_count=' + this.radius_count);

                if (this.radius_count > 0) {
                    this.callDatabook();
                }
            },
            applyFilters() {
                console.log('applying filters');
                console.log('this.record_count=' + this.record_count);

                this.markers_array = [];
                this.callDatabook();
            },
            async addPinToMap() {
                console.log('adding marker');

                console.log('tabs=' + this.tabs);

                console.log('this.pins=' + this.pins);
                console.log('this.places=' + this.places);
                console.log('this.center=' + this.center);

                console.log('this.twentyTwenty=' + this.twentyTwenty);
                console.log('this.pinlatlng=' + this.pinlatlng);
                console.log('this.circlelatlng=' + this.circlelatlng);
                console.log('this.currentPlace=' + this.currentPlace);
                console.log('this.currentPlace2020=' + this.currentPlace2020);

                //Insert space in correct place if postcode - this.currentPlace
                if (this.currentPlace !== '') {
                    var parts = this.currentPlace.match(/^([A-Z,a-z]{1,2}\d{1,2}[A-Z,a-z]?)\s*(\d[A-Z,a-z]{2})$/);

                    if (parts !== null) {
                        parts.shift();
                        this.currentPlace = parts.join(' ');
                    }
                }

                //Insert space in correct place if postcode - this.currentPlace2020
                if (this.currentPlace2020 !== '') {
                    var parts = this.currentPlace2020.match(/^([A-Z,a-z]{1,2}\d{1,2}[A-Z,a-z]?)\s*(\d[A-Z,a-z]{2})$/);

                    if (parts !== null) {
                        parts.shift();
                        this.currentPlace2020 = parts.join(' ');
                    }
                }

                /*if (this.pinlatlng != '') {
                    this.removeCircle();
                    this.callDatabook();
                    return false;
                }*/

                /*if (this.currentPlace == '') {
                    this.errorDialog = true;
                    return false;
                }*/

                if (this.currentPlace || this.currentPlace2020) {
                    let geocoder = new this.google.maps.Geocoder();

                    var address;
                    if (this.currentPlace) {
                        address = `"${this.currentPlace.toUpperCase().split(',').join('","')}"`;
                    } else {
                        address = `"${this.currentPlace2020.toUpperCase().split(',').join('","')}"`;
                    }

                    await this.callDatabook();

                    geocoder.geocode({'address': this.currentPlace.toUpperCase().split(',')[0]}, (results, status) => {

                        console.log('status=' + status);

                        if (status == google.maps.GeocoderStatus.OK) {
                            this.markers = [];
                            this.places = [];
                            this.markers_array = [];

                            console.log('lat=' + results[0].geometry.location.lat());
                            console.log('lng=' + results[0].geometry.location.lng());

                            this.center = {
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng()
                            };
                            //this.markers.push({position: this.center});
                            //this.pinlatlng = 'Pin 1 (' + this.center.lat.toFixed(4) + ',' + this.center.lng.toFixed(4) + ')';

                            this.add_pin_disabled = true;
                        }

                      this.loading = false;
                    });
                }
            },
            addRadiusTextSearch() {
                console.log('addRadiusTextSearch');

                    let geocoder = new this.google.maps.Geocoder();

                    let address = this.currentPlaceRadius;

                    geocoder.geocode({'address': address}, (results, status) => {

                        console.log('status=' + status);

                        if (status == google.maps.GeocoderStatus.OK) {

                            console.log('lat=' + results[0].geometry.location.lat());
                            console.log('lng=' + results[0].geometry.location.lng());

                            let place = {
                                latLng: results[0].geometry.location
                            };

                            this.addingCircle = true;
                            this.getLocation(place);
                        }
                    });
            },
            geolocate() {
                navigator.geolocation.getCurrentPosition(position => {
                    console.log('Your current position is:');
                    console.log(`Latitude : ${position.coords.latitude}`);
                    console.log(`Longitude: ${position.coords.longitude}`);
                    console.log(`More or less ${position.coords.accuracy} meters.`);
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                }, err => {
                    console.log('error in getCurrentPosition');
                    console.log(err.message);

                    if (window.sessionStorage.getItem('templatingValues') !== "undefined") {
                        var templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));

                        console.log('templatingValues.varUser_PostCode=' + templatingValues.varUser_PostCode);

                        this.$gmapApiPromiseLazy().then(() => {
                            let geocoder = new this.google.maps.Geocoder();
                            let address = templatingValues.varUser_PostCode;

                            geocoder.geocode({'address': address}, (results, status) => {
                                console.log('status=' + status);

                                if (status == google.maps.GeocoderStatus.OK) {
                                    console.log('lat=' + results[0].geometry.location.lat());
                                    console.log('lng=' + results[0].geometry.location.lng());

                                    this.center = {
                                        lat: results[0].geometry.location.lat(),
                                        lng: results[0].geometry.location.lng()
                                    };

                                } else {
                                    this.center = {
                                        lat: 51.5049,
                                        lng: -0.0786
                                    };
                                }
                            });
                        })
                    } else {
                        this.center = {
                            lat: 51.5049,
                            lng: -0.0786
                        };
                    }
                })
            },
            getLocation(place) {
                console.log('getLocation');
                console.log('this.tab_selected=' + this.tab_selected);
                console.log('this.circles.length=' + this.circles.length);

                if (this.tab_selected == 'radius' && this.circles.length < 4) {
                    console.log('addingCircle: true');
                    console.log('on:click ', place);

                    //this.distance = Number(this.radius_metres[this.radius.value]);
                    this.distance = Number(this.radius.value) * 1000;

                    console.log('radius.value: ' + this.radius.value);
                    console.log('distance: ' + this.distance);
                    console.log('place.latLng: ' + place.latLng);

                    ++this.radius_count;

                    var radius_selected;
                    if (this.circle1_selected == false) {
                        this.circle1_selected = true;
                        radius_selected = 1;
                    } else if (this.circle2_selected == false) {
                        this.circle2_selected = true;
                        radius_selected = 2;
                    } else if (this.circle3_selected == false) {
                        this.circle3_selected = true;
                        radius_selected = 3;
                    } else if (this.circle4_selected == false) {
                        this.circle4_selected = true;
                        radius_selected = 4;
                    }

                    //this.area_colour = this.getShapeColour(this.radius_count - 1);
                    this.area_colour = this.getShapeColour(radius_selected - 1);
                    //this.area_colour = this.getShapeColour(0);
                    console.log('area_colour: ' + this.area_colour);
                    console.log('place=' + JSON.stringify(place));

                    this.center = {
                        lat: place.latLng.lat(),
                        lng: place.latLng.lng()
                    };

                    this.circles.push({position: this.center, distance: this.distance, colour: this.area_colour});

                    console.log('this.circles: ' + JSON.stringify(this.circles));

                    //this.circlelatlng = 'Radius ' + this.radius_count + ' (' + (this.distance / 1000).toFixed(4) + ' km)';

                    this.addingCircle = false;

                    this.callDatabook();
                }
            },
            getLatLng(address) {
                console.log('getLatLng address: ' + address);

                const firstAddress = address.split(',')[0];

                var google_api_url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + firstAddress + '&region=GB&key=AIzaSyCSIvkEbfpySo-5542Xv-Gq-NLBINAab9Q';
                console.log(google_api_url);

                return new Promise((resolve, reject) => {
                    Axios({
                        method: 'get',
                        url: google_api_url,
                        crossdomain: true
                    })
                    .then(response => {
                        console.log(response);

                        const results = response.data.results && response.data.results.length
                          ? response.data.results[0].geometry.location
                          : null;

                        resolve(results);
                    })
                    .catch(error => {
                        if (error.response) {
                            console.log('getLatLng failure: ' + error.response);
                            reject(error);
                        }
                    })
                })
            },
            getShapeColour(count) {
                console.log('getShapeColour count: ' + count);

                if (count > this.map_colours.length) {
                    var division = Math.round(count / this.map_colours.length),
                        count = count - (this.map_colours.length * division);

                    if (count < 0) {
                        count = 0;
                    }
                }
                return this.map_colours[count];
            },
            getAddressParam(property) {
                var addressParam = '';

                if (property.addr1 != '') {
                    addressParam += property.addr1 + ' ';
                }
                if (property.addr2 != '') {
                    addressParam += property.addr2 + ' ';
                }
                if (property.addr3 != '') {
                    addressParam += property.addr3 + ' ';
                }
                if (property.addr4 != '') {
                    addressParam += property.addr4 + ' ';
                }
                if (property.addr5 != '') {
                    addressParam += property.addr5 + ' ';
                }
                if (property.addr6 != '') {
                    addressParam += property.addr6 + ' ';
                }
                if (property.postcode != '') {
                    addressParam += property.postcode + ' ';
                }

                addressParam = addressParam.substring(0, addressParam.length - 1).replace(/ /g, '%20');

                return addressParam;
            },
            async callDatabook() {
                console.log('this.pinlatlng=' + this.pinlatlng);
                console.log('this.currentPlace = ' + this.currentPlace);

                let setLocationFromFirstAddress = false;

                /*if (this.currentPlace !== '') {
                    if (this.twentyTwenty === '' && this.radius === '') {
                        this.errorDialog = true;
                        return false;
                    }
                }

                if (this.twentyTwenty !== '') {
                    if (this.pinlatlng == '' && this.currentPlace == '') {
                        this.errorDialog = true;
                        return false;
                    }
                }

                if (this.radius !== '') {
                    if (this.circlelatlng == '' && this.currentPlace == '') {
                        this.errorDialog = true;
                        return false;
                    }
                }*/

                var selected_filters = '',
                    operator,
                    range;

                if (this.council_tax_band_icon > 0) {
                    console.log('council tax band filter applied');

                    operator = this.council_tax_band_1_choices[this.council_tax_band_1];
                    switch (operator) {
                        case 'more than':
                        case 'less than':
                            range = this.council_tax_band_2_choices[this.council_tax_band_2];

                            for (var i = 0; i < this.switchable_opts[operator][range].length; i++) {
                                selected_filters += '&council_tax_band=' + this.switchable_opts[operator][range][i];
                            }

                            selected_filters += '&council_tax_band_selected=' + operator + '||' + this.council_tax_band_2_choices[this.council_tax_band_2];

                            break;
                        case 'between':
                            range = this.council_tax_band_2_choices[this.council_tax_band_2] + '-' + this.council_tax_band_2_choices[this.council_tax_band_3];

                            for (var i = 0; i < this.switchable_opts[operator][range].length; i++) {
                                selected_filters += '&council_tax_band=' + this.switchable_opts[operator][range][i];
                            }

                            selected_filters += '&council_tax_band_selected=' + operator + '||' + this.council_tax_band_2_choices[this.council_tax_band_2] + '||' + this.council_tax_band_2_choices[this.council_tax_band_3];

                            break;
                        case 'only':
                            var selected = operator + '||';

                            for (var i = 0; i < this.selected_council_tax_bands.length; i++) {
                                selected_filters += '&council_tax_band=' + this.selected_council_tax_bands[i];
                                selected += this.selected_council_tax_bands[i] + ',';
                            }

                            selected_filters += '&council_tax_band_selected=' + selected.substring(0, selected.length - 1) + '||';

                            break;
                    }
                }

                if (this.house_value_icon > 0) {
                    console.log('house value filter applied');

                    operator = this.house_value_1_choices[this.house_value_1];
                    switch (operator) {
                        case 'more than':
                        case 'less than':
                            range = this.house_value_2_choices[this.house_value_2];

                            for (var i = 0; i < this.switchable_opts[operator][range].length; i++) {
                                selected_filters += '&council_tax_band_price=' + this.switchable_opts[operator][range][i];
                            }

                            selected_filters += '&house_value_selected=' + operator + '||' + this.house_value_2_choices[this.house_value_2];

                            break;
                        case 'between':
                            range = this.house_value_2_choices[this.house_value_2] + '-' + this.house_value_3_choices[this.house_value_3];

                            for (var i = 0; i < this.switchable_opts[operator][range].length; i++) {
                                selected_filters += '&council_tax_band_price=' + this.switchable_opts[operator][range][i];
                            }

                            selected_filters += '&house_value_selected=' + operator + '||' + this.house_value_2_choices[this.house_value_2] + '||' + this.house_value_2_choices[this.house_value_3];

                            break;
                    }
                }

                if (this.occupier_icon > 0) {
                    console.log('occupier filter applied');

                    var occupier_choice = this.occupier_choices[this.occupier];
                    selected_filters += '&tenure=' + this.switchable_opts.occupier[occupier_choice];

                    selected_filters += '&occupied_by_filter_selected=' + '||' + occupier_choice + '||';
                }

                if (this.residence_type_icon > 0) {
                    console.log('residence type filter applied');

                    var residence_type_choice = this.residence_type_choices[this.residence_type];

                    if (residence_type_choice == 'multiple') {
                        var selected = 'only||';

                        for (var i = 0; i < this.selected_residence_types.length; i++) {
                            selected_filters += '&residence_type=' + this.switchable_opts.residence_type[this.selected_residence_types[i]];
                            selected += this.selected_residence_types[i] + ',';
                        }

                        selected_filters += '&residence_type_selected=' + selected.substring(0, selected.length - 1) + '||';

                    } else {
                        selected_filters += '&residence_type=' + this.switchable_opts.residence_type[residence_type_choice];

                        selected_filters += '&residence_type_selected=' + '||' + residence_type_choice + '||';
                    }
                }

                console.log('selected_filters=' + selected_filters);

                this.loading = true;

                //this.query_string = selected_filters + '&2020rows=' + this.twentyTwenty + '&rows=1&near=' + this.center.lng + ' ' + this.center.lat;
                //this.data_url = `${process.env.VUE_APP_TKGATEWAY}/search?token=` + this.databook_auth_token + this.query_string;
                this.dataProvider = 'Databook';

                console.log('this.tab_selected=' + this.tab_selected);

                if (this.tab_selected == 'location') {
                    if (this.currentPlace !== '') {
                        var locationLatLng = await this.getLatLng(this.currentPlace);
                        console.log(locationLatLng);

                        if (locationLatLng) {
                          this.center = {
                            lat: locationLatLng.lat,
                            lng: locationLatLng.lng
                          };
                        } else {
                          setLocationFromFirstAddress = true;
                        }

                        // var free_text = '"' + this.currentPlace.toUpperCase() + '"';
                        const free_text = `"${this.currentPlace.toUpperCase().split(',').join('","')}"`;
                        this.query_string = qs.stringify({
                            'freetext': free_text,
                        });
                    }
                }

                if (this.tab_selected == 'radius') {
                    if (this.circles.length > 0) {
                        var circles = '',
                            center;

                        for (var i = 0; i < this.circles.length; i++) {
                            if (circles !== '') {
                                circles += ' OR ';
                            }

                            circles += qs.stringify({
                                'radius': '{!geofilt sfield=location d=' + (this.circles[i].distance / 1000) + ' pt=' + this.circles[i].position.lat + ',' + this.circles[i].position.lng + '}'
                            });

                            center = {
                                lat: this.circles[i].position.lat,
                                lng: this.circles[i].position.lng
                            };
                        }

                        console.log('center=' + JSON.stringify(center));

                        this.center = center;
                        this.query_string = circles;
                    }
                }

                if (this.tab_selected == '2020') {
                    if (this.currentPlace2020 !== '') {
                        var twentyLatLng = await this.getLatLng(this.currentPlace2020);
                        console.log(twentyLatLng);

                        if (twentyLatLng) {
                          this.center = {
                            lat: twentyLatLng.lat,
                            lng: twentyLatLng.lng
                          };
                        } else {
                          setLocationFromFirstAddress = true;
                        }

                        this.query_string = qs.stringify({
                            '2020rows': this.twentyTwenty,
                            'near': this.center.lat + ', ' + this.center.lng,
                        });
                    }
                }

                //if (this.radius !== '') {
                //    this.query_string = qs.stringify({
                //        'radius': '{!geofilt sfield=location d=' + this.radius + ' pt=' + this.center.lat + ',' + this.center.lng + '}'
                //    });
                //}

                //if (this.radius !== '') {
                //    this.query_string = qs.stringify({
                //        'radius': '{!geofilt sfield=location d=' + (this.distance / 1000) + ' pt=' + this.center.lat + ',' + this.center.lng + '}'
                //    });
                //}

                this.query_string += selected_filters;
                //this.data_url = `http://test.tkv4.co.uk/api/1.1/zpgapi.asp?method=DatabookSearch&code=zpg1&customerRef=RAV02`;
                this.data_url = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=DatabookSearch&code=zpg1&customerRef=RAV02`;

                console.log('qs=' + this.query_string);
                console.log('endpoint=' + this.data_url);

                let response;

                try {
                  response = await Axios({
                    method: 'post',
                    url: this.data_url,
                    crossdomain: true,
                    data: this.query_string,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                  });
                } catch (error) {
                  if (error.response) {
                    //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                    console.log('auth failure: ' + error.response);
                  }

                  this.loading = false;
                }

              if (! response) {
                  return;
                }

              console.log('search success');
              console.log(response);

              var markerOptions = {
                url: 'https://rpsassets.blob.core.windows.net/rpsimages/images/icons/home-address.png',
                size: {width: 60, height: 60, f: 'px', b: 'px',},
                scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
                anchor: new google.maps.Point(15, 30),
              };

              response.data.result.propertyAddresses.forEach((item, index) => {
                if (index > 99) {
                  return;
                }

                const [lat, lng] = item.location.split(',');

                this.markers_array.push({
                  position: {
                    lat: +lat,
                    lng: +lng,
                  },
                  markerOptions,
                });
              });
``
              // var latlng;
              // for (var item, i = 0; item = response.data.result.propertyAddresses[i++];) {
              //     latlng = item.location.split(',');

              //     var markerExists = false;

              //     for (var marker, j = 0; marker = this.markers_array[j++];) {
              //         if (marker.position.lat === parseFloat(latlng[0]) && marker.position.lng === parseFloat(latlng[1])) {
              //             markerExists = true;
              //             break;
              //         }
              //     }

              //     //if (this.markers_array.indexOf({position: {lat: parseFloat(latlng[0]), lng: parseFloat(latlng[1])}, markerOptions: markerOptions}) === -1) {
              //     if (!markerExists) {
              //         this.markers_array.push({position: {lat: parseFloat(latlng[0]), lng: parseFloat(latlng[1])}, markerOptions: markerOptions});
              //     }
              // }

              if (setLocationFromFirstAddress) {
                console.log('setLocationFromFirstAddress', setLocationFromFirstAddress);
                const lastAddressLatLng = response.data.result.propertyAddresses[0].location;

                const [lat, lng] = lastAddressLatLng.split(',');

                this.center = {
                  lat: +lat,
                  lng: +lng,
                };
              }

              this.record_count = response.data.result.count;

              this.flashing = true;
              setTimeout(() => this.flashing = false, 200);

              window.sessionStorage.setItem('_searchType', this.tab_selected);
              window.sessionStorage.setItem('_currentPlace', this.currentPlace);
              window.sessionStorage.setItem('_circles', JSON.stringify(this.circles));
              window.sessionStorage.setItem('_currentPlace2020', this.currentPlace2020);

              this.loading = false;
            },
            previewData() {
                if (this.record_count == 0) {
                    return;
                }

                //Check if the order id exists and create order if not
                if (window.sessionStorage.getItem('_order_id') !== "undefined") {
                    this.loading = true;

                    const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

                    const update_body = [
                        {
                            "value": this.query_string,
                            "path": "/dataUrl",
                            "op": "replace",
                            "from": "string"
                        },
                        {
                            "value": this.dataProvider,
                            "path": "/dataProvider",
                            "op": "replace",
                            "from": "string"
                        }
                    ]

                    Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log(response.data);

                            window.sessionStorage.setItem('_databook_auth_token', this.databook_auth_token);

                            this.loading = false;
                            this.navigate('data-preview');
                        })
                        .catch(error => {
                            if (error.response) {
                                //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                                console.log('data order patch failure: ' + JSON.stringify(error.response));
                            }

                            this.loading = false;
                        });
                }
            },
            clickSearchText() {
                console.log('text clicked');
            },
            clickBandIcon() {
                if (this.council_tax_band_icon == this.icon_choices.length - 1) {
                    this.council_tax_band_icon = 0;
                    this.show_house_value_tooltip = false;
                } else {
                    this.council_tax_band_icon++;
                    this.show_house_value_tooltip = true;
                }
            },
            clickBand1() {
                if (this.council_tax_band_icon > 0) {
                    if (this.council_tax_band_1_choices[this.council_tax_band_1] == 'between') {
                        this.clickBand3();
                    }

                    if (this.council_tax_band_1 == this.council_tax_band_1_choices.length - 1) {
                        this.council_tax_band_1 = 0;
                    } else {
                        this.council_tax_band_1++;
                    }
                }
            },
            clickBand2() {
                if (this.council_tax_band_icon > 0) {
                    if (this.council_tax_band_2 == this.council_tax_band_2_choices.length - 1) {
                        this.council_tax_band_2 = 0;
                    } else {
                        this.council_tax_band_2++;
                    }

                    if (this.council_tax_band_1_choices[this.council_tax_band_1] == 'between') {
                        this.council_tax_band_3 = this.council_tax_band_2 + 1;
                    }
                }
            },
            clickBand3() {
                if (this.council_tax_band_icon > 0) {
                    if (this.council_tax_band_3 == this.council_tax_band_2_choices.length - 1) {
                        this.council_tax_band_3 = 0;
                    } else {
                        this.council_tax_band_3++;
                    }
                }
            },
            clickHouseValueIcon() {
                if (this.house_value_icon == this.icon_choices.length - 1) {
                    this.house_value_icon = 0;
                    this.show_council_tax_band_tooltip = false;
                } else {
                    this.house_value_icon++;
                    this.show_council_tax_band_tooltip = true;
                }
            },
            clickHouseValue1() {
                if (this.house_value_icon > 0) {
                    if (this.house_value_1_choices[this.house_value_1] == 'between') {
                        this.clickHouseValue3();
                    }

                    if (this.house_value_1 == this.house_value_1_choices.length - 1) {
                        this.house_value_1 = 0;
                    } else {
                        this.house_value_1++;
                    }
                }
            },
            clickHouseValue2() {
                if (this.house_value_icon > 0) {
                    if (this.house_value_2 == this.house_value_2_choices.length - 1) {
                        this.house_value_2 = 0;
                    } else {
                        this.house_value_2++;
                    }

                    if (this.house_value_1_choices[this.house_value_1] == 'between') {
                        this.house_value_3 = this.house_value_2 + 1;
                    }
                }
            },
            clickHouseValue3() {
                if (this.house_value_icon > 0) {
                    if (this.house_value_3 == this.house_value_3_choices.length - 1) {
                        this.house_value_3 = 0;
                    } else {
                        this.house_value_3++;
                    }
                }
            },
            clickOccupierIcon() {
                if (this.occupier_icon == this.icon_choices.length - 1) {
                    this.occupier_icon = 0;
                } else {
                    this.occupier_icon++;
                }
            },
            clickOccupier() {
                if (this.occupier_icon > 0) {
                    if (this.occupier == this.occupier_choices.length - 1) {
                        this.occupier = 0;
                    } else {
                        this.occupier++;
                    }
                }
            },
            clickResidenceTypeIcon() {
                if (this.residence_type_icon == this.icon_choices.length - 1) {
                    this.residence_type_icon = 0;
                } else {
                    this.residence_type_icon++;
                }
            },
            clickResidenceType() {
                if (this.residence_type_icon > 0) {
                    if (this.residence_type == this.residence_type_choices.length - 1) {
                        this.residence_type = 0;
                    } else {
                        this.residence_type++;
                    }
                }
            },
            pinDragged(index, location) {
                console.log('updateCoordinates');
                console.log('lat=' + location.lat());
                console.log('lng=' + location.lng());

                this.center = {
                    lat: location.lat(),
                    lng: location.lng()
                };

                console.log('this.center.lat=' + this.center.lat);
                console.log('this.center.lng=' + this.center.lng);
                console.log('this.center.lat (4 dec)=' + this.center.lat.toFixed(4));
                console.log('this.center.lng (4 dec)=' + this.center.lng.toFixed(4));

                this.pinlatlng = 'Pin 1 (' + this.center.lat.toFixed(4) + ',' + this.center.lng.toFixed(4) + ')';
                this.markers_array = [];

                this.callDatabook();
            },
            radiusChanged(index, radius) {
                console.log('radiusChanged');

                console.log('index=' + index);

                var circle = this.circles[index];
                console.log(JSON.stringify(circle));

                console.log('radius=' + radius);
                console.log('this.distance=' + this.distance);

                if (this.distance == radius) {
                    return false;
                }

                //this.distance = radius;
                //this.circlelatlng = 'Radius 1 (' + (this.distance / 1000).toFixed(4) + ' km)';

                console.log('before:' + JSON.stringify(this.circles));

                this.circles.splice(index, 1, {position: circle.position, distance: radius, colour: circle.colour});

                console.log('after:' + JSON.stringify(this.circles));

                this.markers_array = [];

                this.callDatabook();
            },
            centerChanged(index, center) {
                console.log('centerChanged');

                console.log('index=' + index);

                var circle = this.circles[index];
                console.log(JSON.stringify(circle));

                console.log('center.lat=' + center.lat());
                console.log('center.lng=' + center.lng());
                console.log('circle.position.lat=' + circle.position.lat);
                console.log('circle.position.lng=' + circle.position.lng);

                if (circle.position.lat == center.lat() && circle.position.lng == center.lng()) {
                    return false;
                }

                var new_center = {
                    lat: center.lat(),
                    lng: center.lng()
                };

                //this.circles.splice(0, 1);
                //this.circles.push({position: this.center});

                console.log('before:' + JSON.stringify(this.circles));

                this.circles.splice(index, 1, {position: new_center, distance: circle.distance, colour: circle.colour});

                console.log('after:' + JSON.stringify(this.circles));

                this.markers_array = [];

                this.callDatabook();
            },
            showCircles(visible) {
                for (let i = 0; i < this.circles.length; i++) {
                    this.circles[i]["visibility"] = visible;
                }
            },
            twentyTwentySelected() {
                console.log('twentyTwentySelected');

                //this.radius = '';
            },
            radiusSelected() {
                console.log('radiusSelected');

                this.setRadius(this.radius);

                window.sessionStorage.setItem('_radius_value', this.radius.value);
                //this.twentyTwenty = '';
            },
            setRadius(radius) {
                console.log('setRadius');

                var selected_text,
                    selected_value;

                if (this.distance_unit === 'km') {
                    for (var i = 0; i < this.radius_choices_km.length; i++)
                    {
                        if (this.radius_choices_km[i].value == radius)
                        {
                            selected_text = this.radius_choices_km[i].text;
                            selected_value = this.radius_choices_km[i].value;
                        }
                    }
                } else {
                    for (var i = 0; i < this.radius_choices_miles.length; i++)
                    {
                        if (this.radius_choices_miles[i].value == radius)
                        {
                            selected_text = this.radius_choices_miles[i].text;
                            selected_value = this.radius_choices_miles[i].value;
                        }
                    }
                }

                this.radius = { 'text': selected_text, 'value': selected_value };

                console.log(JSON.stringify(this.radius));
            },
            clickDistanceUnit() {
                console.log('search=' + (this.radius.text.search(/km|mi/)));

                if (this.distance_unit === 'km') {
                    this.distance_unit = 'miles';
                    this.radius_choices = this.radius_choices_miles;

                    var new_value;
                    if (this.radius.text.search(/km|mi/) > 0){
                        new_value = this.toMetres(this.radius.value, 'mi', false);
                    } else {
                        new_value = this.radius.value
                    }

                    this.radius = { 'text': this.radius.text, 'value': new_value.toString() };

                    console.log('this.radius(mi)=' + JSON.stringify(this.radius));
                } else {
                    this.distance_unit = 'km';
                    this.radius_choices = this.radius_choices_km;

                    var new_value;
                    if (this.radius.text.search(/km|mi/) > 0){
                        new_value = this.metresTo(this.radius.value, 'mi', false);
                    } else {
                        new_value = this.radius.value
                    }

                    this.radius = { 'text': this.radius.text, 'value': new_value.toString() };

                    console.log('this.radius(km)=' + JSON.stringify(this.radius));
                }

                window.sessionStorage.setItem('_radius_units', this.distance_unit);
                window.sessionStorage.setItem('_radius_value', this.radius.value);
            },
            metresTo(value, unit, display_unit) {
                var string = '';
                switch (unit) {
                    case 'mi':
                        //string = value / 1609.344;
                        string = value / 1.609344;
                    break;
                    default:
                        //km
                        //string = value / 1000;
                        string = value;
                    break;
                }

                if (display_unit === true) {
                    string = string.toFixed(3) + ' ' + unit;
                }

                return string;
            },
            toMetres(value, unit, display_unit) {
                var string = '';
                switch (unit) {
                    case 'mi':
                        //string = value * 1609.344;
                        string = value * 1.609344;
                    break;
                    default:
                        //km
                        //string = value * 1000;
                        string = value;
                    break;
                }

                if (display_unit === true) {
                    string = string.toFixed(3) + ' ' + unit;
                }

                return string;
            }
        }
    };
</script>

